import React from 'react';

/**
 * Driving-vs-idle split as a two-segment bar plus the numeric percentage.
 *
 * `idlePct` is the duration-weighted idle share from weightedIdleShare. When it is null
 * the signal is absent rather than zero, so render an em dash — reporting 0% idle for a
 * missing column would read as a clean fleet, which is the opposite of the truth.
 */
const OdShareBar = (props) => {
    const { idlePct } = props;

    if (idlePct === null || idlePct === undefined) {
        return <span className="od-cell-muted">—</span>;
    }

    const idle = Math.max(0, Math.min(100, Number(idlePct) || 0));
    const drive = 100 - idle;

    return (
        <div className="od-share">
            <div
              className="od-bar"
              title={`Driving ${drive.toFixed(1)}% · Idle ${idle.toFixed(1)}%`}
            >
                <i className="od-bar-drive" style={{ width: `${drive}%` }} />
                <i className="od-bar-idle" style={{ width: `${idle}%` }} />
            </div>
            <span className="od-share-value">{`${idle.toFixed(1)}%`}</span>
        </div>
    );
};

export default OdShareBar;
